type TToggle = '0' | '1';
export const parseBoolean = (params: TToggle): boolean =>
  params && typeof params === 'string' ? params === '1' : false;
